import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=c80277b2&"
import script from "./Title.vue?vue&type=script&setup=true&lang=js&"
export * from "./Title.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Title.vue?vue&type=style&index=0&id=c80277b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports